import { observable, action } from 'mobx';
import { Guarantors } from 'api';

class GuarantorStore {
  @observable guarantor;

  @observable fetchState;

  anketId;

  guarantorId;

  @action.bound
  async getGuarantor(anketId, guarantorId) {
    if (this.anketId === anketId && this.guarantorId === guarantorId) {
      return;
    }

    this.fetchState = 'pending';

    try {
      const response = await Guarantors.getGuarantor(anketId, guarantorId);
      this.guarantor = response.data;
      this.fetchState = 'fulfilled';
      this.anketId = anketId;
      this.guarantorId = guarantorId;
    } catch (e) {
      this.fetchState = 'rejected';
    }
  }
}

const guarantorStore = new GuarantorStore();

export default guarantorStore;
